import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleQuestion,
    faPen,
    faStar,
    faTrashCan,
    faUserCheck,
} from '@fortawesome/free-solid-svg-icons';
import { Rating } from 'react-simple-star-rating';
import { useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/fr';

import MyModalModifNote from './NoteModal/MyModalModifNote';
import MyModalDeleteEvaluationEleve from './EvaluationModal/MyModalDeleteEvaluationEleve';
import { orderStudents } from '../utils/studentOrder';

const RATING_LABELS = {
    0: 'Non évalué',
    1: 'Non atteint',
    2: 'Partiellement atteint',
    3: 'Atteint',
    4: 'Dépassé',
};

export default function ClasseNoteEleveCard({positionEleve, activity, objective, evaluatedStudents}) {
    const [editModalIsOpen, setEditModalIsOpen] = React.useState(false);
    const [deleteModalIsOpen, setDeleteModalIsOpen] = React.useState(false);
    const [selectedEvaluation, setSelectedEvaluation] = React.useState({});

    const evaluations = useSelector(state => state.noteDetail.arr);
    const students = orderStudents(evaluations, positionEleve);

    function openEditModal(evaluation) {
        setSelectedEvaluation(evaluation);
        setEditModalIsOpen(true);
    }

    function openDeleteModal(evaluation) {
        setSelectedEvaluation(evaluation);
        setDeleteModalIsOpen(true);
    }

    function handleCloseModal(event, modalNumber) {
        if (modalNumber === 1) setEditModalIsOpen(false);
        if (modalNumber === 2) setDeleteModalIsOpen(false);
    }

    return (
        <>
            <MyModalModifNote
                IsModalOpened={editModalIsOpen}
                onCloseModal={handleCloseModal}
                infoNote={selectedEvaluation}
                key={editModalIsOpen ? 'edit-evaluation-open' : 'edit-evaluation-closed'}
            />
            <MyModalDeleteEvaluationEleve
                IsModalOpened={deleteModalIsOpen}
                onCloseModal={handleCloseModal}
                infoNote={selectedEvaluation}
                key={deleteModalIsOpen ? 'delete-student-evaluation-open' : 'delete-student-evaluation-closed'}
            />

            <section className="ae-workspace-card">
                <header className="ae-workspace-card-header">
                    <span className="ae-workspace-card-icon ae-workspace-card-icon--gold">
                        <FontAwesomeIcon icon={faStar} />
                    </span>
                    <div>
                        <h2>{activity || 'Résultats des élèves'}</h2>
                        <p>{objective || "Consultez les résultats enregistrés pour cette évaluation."}</p>
                    </div>
                    <div className="ae-workspace-header-metric" aria-label={`${evaluatedStudents || 0} élèves évalués`}>
                        <FontAwesomeIcon icon={faUserCheck} />
                        <span>
                            <strong>{evaluatedStudents || 0}</strong>
                            <small>élèves évalués</small>
                        </span>
                    </div>
                </header>

                <div className="ae-workspace-card-body">
                    <details className="ae-workspace-rating-legend">
                        <summary>
                            <FontAwesomeIcon icon={faCircleQuestion} />
                            <span>Barème des évaluations</span>
                        </summary>
                        <div className="ae-workspace-rating-legend-grid">
                            {Object.entries(RATING_LABELS).map(([value, label]) => (
                                <span key={value}>
                                    <Rating
                                        initialValue={Number(value)}
                                        size={17}
                                        iconsCount={4}
                                        fillColor="#f5a400"
                                        emptyColor="#d5dbe7"
                                        readonly
                                    />
                                    <small>{label}</small>
                                </span>
                            ))}
                        </div>
                    </details>

                    {students.length > 0 ? (
                        <div className="ae-workspace-table-wrap">
                            <table className="ae-workspace-table ae-workspace-table--student-evaluations">
                                <thead>
                                    <tr>
                                        <th>Prénom</th>
                                        <th>Nom</th>
                                        <th>Niveau</th>
                                        <th>Évaluation</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.map((row) => {
                                        const note = Number(row.note) || 0;
                                        return (
                                            <tr key={`${row.id_eleve}-${row.id_seance}`}>
                                                <td data-label="Prénom"><strong>{row.prenom || '—'}</strong></td>
                                                <td data-label="Nom">{row.nom || '—'}</td>
                                                <td data-label="Niveau">{row.niveau || '—'}</td>
                                                <td data-label="Évaluation">
                                                    <span className="ae-workspace-student-rating" aria-label={RATING_LABELS[note] || 'Non évalué'}>
                                                        <Rating
                                                            initialValue={note}
                                                            size={19}
                                                            iconsCount={4}
                                                            fillColor="#f5a400"
                                                            emptyColor="#d5dbe7"
                                                            readonly
                                                        />
                                                        <small>{RATING_LABELS[note] || 'Non évalué'}</small>
                                                    </span>
                                                </td>
                                                <td data-label="Date">
                                                    {row.date_note ? moment(row.date_note).format('DD MMMM YYYY') : '—'}
                                                </td>
                                                <td data-label="Actions">
                                                    <div className="ae-workspace-row-actions">
                                                        <button type="button" className="ae-workspace-secondary-button" onClick={() => openEditModal(row)}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                            <span>Modifier</span>
                                                        </button>
                                                        <button type="button" className="ae-workspace-danger-button" onClick={() => openDeleteModal(row)}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                            <span>Supprimer</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-workspace-empty">Aucun élève n'a encore été évalué pour cette activité.</p>
                    )}
                </div>
            </section>
        </>
    );
}
